import type { RouteObject } from 'react-router-dom';
import { SETTINGS_TABS } from './settings-tab-config';

const SettingsRoutes: RouteObject[] = SETTINGS_TABS.map((tab) => ({
  path: tab.value,
  icon: tab.icon,
  id: tab.label,
  element: tab.content,
  allowedRoles: tab.roles,
}));

export default SettingsRoutes;
